import { render, staticRenderFns } from "./gangwei.vue?vue&type=template&id=577ddcb9&scoped=true&"
import script from "./gangwei.vue?vue&type=script&lang=js&"
export * from "./gangwei.vue?vue&type=script&lang=js&"
import style0 from "./gangwei.vue?vue&type=style&index=0&id=577ddcb9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577ddcb9",
  null
  
)

export default component.exports